<template>
  <el-dialog
    :append-to-body="appendToBody"
    v-bind="$attrs"
    v-on="$listeners"
    :width="width || $pxToRem(588)"
    :close-on-click-modal="false"
    ref="dialog"
    :visible="visible"
    :before-close="handleCloseDialog"
    :show-close="false"
  >
    <div :class="{ 'dialog-body-no-footer': !showFooter }">
      <slot></slot>
    </div>
    <template #title v-if="showHeader">
      <div class="header flex items-start justify-between">
        <div class="title">{{ title }}</div>
        <img v-if="showClose" class="close" src="@/assets/common/close.png" alt="" @click="handleCloseDialog" />
      </div>
    </template>
    <template #footer v-if="showFooter">
      <div class="flex items-center justify-center">
        <slot name="footer"></slot>
        <el-button @click="handleCancel" v-if="showCancel" class="btn cancelBtn">{{ cancelText }}[Esc]</el-button>
        <el-button @click="handleConfirm" class="btn confirmBtn" type="primary">{{ confirmText }}[Enter]</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
  import { Dialog } from 'element-ui'
  import Mousetrap from 'mousetrap'
  import i18n from '@/locale'
  export default {
    name: 'MgDialog',
    extends: Dialog,
    props: {
      width: String,
      title: {
        type: String,
        default: i18n.t('提示'),
      },
      visible: {
        type: Boolean,
        default: false,
      },
      cancelText: {
        type: String,
        default: i18n.t('取消'),
      },
      confirmText: {
        type: String,
        default: i18n.t('确定'),
      },
      showHeader: {
        type: Boolean,
        default: true,
      },
      showFooter: {
        type: Boolean,
        default: true,
      },
      showCancel: {
        type: Boolean,
        default: true,
      },
      actionCenter: {
        type: Boolean,
        default: true,
      },
      showClose: {
        type: Boolean,
        default: true,
      },
      appendToBody: {
        type: Boolean,
        default: false,
      },
    },

    watch: {
      visible(val) {
        if (val) {
          this.keyboard()
        } else {
          this.keyboardUnbind()
        }
      },
    },
    beforeDestroy() {
      this.keyboardUnbind()
    },

    methods: {
      handleCancel() {
        this.$emit('cancel')
        this.handleCloseDialog()
      },
      handleCloseDialog() {
        this.$emit('update:visible', false)
      },
      handleConfirm() {
        this.$emit('confirm')
      },

      keyboard() {
        let keyboardEvent = {
          Escape: {
            key: 'esc',
            event: this.handleCancel,
          },
          Enter: {
            key: 'enter',
            event: this.handleConfirm,
          },
        }

        this.mousetrap = Mousetrap(document.body)
        this.mousetrap.bind(
          Object.values(keyboardEvent).map((item) => item.key),
          function (e) {
            keyboardEvent[e.key].event(e)
            return false
          }
        )
      },

      /**
       * 快捷键解绑
       */
      keyboardUnbind() {
        if (this.mousetrap) {
          this.mousetrap.unbind(['esc', 'enter'])
          this.mousetrap.destroy()
          this.mousetrap = null
        }
      },
    },
  }
</script>
<style lang="scss" scoped>

  ::v-deep {
    .el-dialog {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      margin: 0 !important;
    }
    .el-dialog__header {
      border: none !important;
      box-sizing: border-box !important;
      display: flex;
      align-items: center;
      padding: 20px 24px;
      font-weight: 600;
      font-size: 22px;
      .header {
        width: 100%;
        .close {
          cursor: pointer;
          width: 28px;
        }
      }
    }
    .el-dialog__body {
      padding: 8px 24px 0 24px;
      .dialog-body-no-footer {
        margin-bottom: 24px;
      }
    }
    .el-dialog__footer {
      border: none;
      padding: 24px;
      .btn {
        width: 190px;
        height: 56px;
      }
      button:nth-child(2) {
        margin-left: 20px;
      }
    }
  }
</style>
